import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { Button } from '../components/ui/Button';
export function About() {
  return <div className="min-h-screen bg-brand-cream" data-id="element-153">
      <HeroSection title="About ReGrowth" subtitle="Trust, transparency, and human grounding." tag="Who We Are" bgColor="lime" textColor="navy" data-id="element-154" />

      {/* Founders */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-155">
        <h2 className="text-4xl font-black uppercase mb-16 text-brand-black" data-id="element-156">
          Who We Are
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-157">
          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-158">
            <div className="w-32 h-32 rounded-full bg-brand-lime flex-shrink-0 border-2 border-brand-black" data-id="element-159"></div>
            <div data-id="element-160">
              <h3 className="text-2xl font-bold text-brand-black mb-1" data-id="element-161">
                Alex Rivera
              </h3>
              <p className="text-brand-lime font-bold uppercase text-sm mb-4" data-id="element-162">
                Co-Founder & Education Lead
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-163">
                Alex is a writer and educator with 10 years of experience in fat
                activism. They believe in the power of collective learning to
                dismantle systems of oppression.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-164">
            <div className="w-32 h-32 rounded-full bg-brand-cyan flex-shrink-0 border-2 border-brand-black" data-id="element-165"></div>
            <div data-id="element-166">
              <h3 className="text-2xl font-bold text-brand-black mb-1" data-id="element-167">
                Jordan Smith
              </h3>
              <p className="text-brand-cyan font-bold uppercase text-sm mb-4" data-id="element-168">
                Co-Founder & Editor
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-169">
                Jordan is an editor and community organizer. Their work focuses
                on the intersection of disability justice and fat liberation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="py-20 bg-brand-navy text-white" data-id="element-170">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
          <h2 className="text-4xl font-black uppercase mb-16 text-brand-lime" data-id="element-172">
            How We Work
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-173">
            <div className="p-8 border border-brand-lime/30 rounded-sm" data-id="element-174">
              <h3 className="text-xl font-bold text-brand-lime mb-4" data-id="element-175">
                Community Care
              </h3>
              <p className="text-gray-300" data-id="element-176">
                We prioritize the wellbeing of our community over profit or
                growth. We move at the speed of trust.
              </p>
            </div>

            <div className="p-8 border border-brand-lime/30 rounded-sm" data-id="element-177">
              <h3 className="text-xl font-bold text-brand-lime mb-4" data-id="element-178">
                Collaboration
              </h3>
              <p className="text-gray-300" data-id="element-179">
                We don't believe in the lone genius myth. All our work is
                collaborative and credits lineage.
              </p>
            </div>

            <div className="p-8 border border-brand-lime/30 rounded-sm" data-id="element-180">
              <h3 className="text-xl font-bold text-brand-lime mb-4" data-id="element-181">
                Boundaries
              </h3>
              <p className="text-gray-300" data-id="element-182">
                We are clear about what we do and don't do. We protect our
                energy to sustain this work for the long haul.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Policies */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-183">
        <h2 className="text-3xl font-black uppercase mb-8 text-brand-black" data-id="element-184">
          Policies & Accessibility
        </h2>
        <div className="space-y-6" data-id="element-185">
          <div className="bg-white p-6 border border-gray-200 shadow-sm" data-id="element-186">
            <h3 className="font-bold text-lg mb-2" data-id="element-187">Accessibility Statement</h3>
            <p className="text-gray-600 mb-4" data-id="element-188">
              We are committed to making our digital spaces accessible to all.
            </p>
            <Button size="sm" variant="outline" color="navy" data-id="element-189">
              Read Full Policy
            </Button>
          </div>

          <div className="bg-white p-6 border border-gray-200 shadow-sm" data-id="element-190">
            <h3 className="font-bold text-lg mb-2" data-id="element-191">Refund Policy</h3>
            <p className="text-gray-600 mb-4" data-id="element-192">
              We offer refunds for courses within 14 days if the content doesn't
              meet your needs.
            </p>
            <Button size="sm" variant="outline" color="navy" data-id="element-193">
              Read Full Policy
            </Button>
          </div>
        </div>
      </section>
    </div>;
}